import { Component, OnInit } from '@angular/core';
import { AmbitService } from '../ambit.service';
import { HttpHelperService } from '../http-helper.service'
import * as firebase from 'firebase';
import { Router } from '@angular/router';
@Component({
  selector: 'app-withdrawls',
  templateUrl: './withdrawls.component.html',
  styleUrls: ['./withdrawls.component.css']
})
export class WithdrawlsComponent implements OnInit {

  public searchList: any = ['email', 'name'];
  public sortColumn: any = 'name';
  public sortType: boolean = false;
  public loading: boolean = false;

  public accountDetails: any;
  public imgURL: any;
  public selectedFile: any;
  public user: any = {};

  public filterStatus: any = 'All';
  public searchQuery: any;
  constructor(public service: AmbitService,
    public http: HttpHelperService,
    public router: Router) {
    if (this.service.adminUser.userAccess.payouts == 'None') {
      this.router.navigate(['/home']);
    }
  }

  ngOnInit() {
    var date = new Date();

    if (date.getDate() > 15) {
      var month = date.getMonth();
      if (month + 1 > 11) {
        date.setMonth(0);
        date.setFullYear(date.getFullYear() + 1);
      } else {
        date.setMonth(month + 1);
      }
    }
    date.setDate(15)
    this.service.payoutDate = Number(date);
  }

  getAccountDetails(uid) {
    var data = this.service.userAccountsList.find(ob => ob['uid'] === uid);
    if (data) {
      this.accountDetails = data;
    } else {
      this.accountDetails = '';
    }
  }

  toggleSortValue(val) {
    if (this.sortColumn == val) {
      this.sortType = !this.sortType;
    } else {
      this.sortColumn = val;
    }
  }

  onChangeStatus() {
    this.service.filteredWithdrawRequests = [];
    if (this.filterStatus == 'All') {
      this.service.filteredWithdrawRequests = this.service.allWithdrawRequests;
    } else {
      for (var i = 0; i < this.service.allWithdrawRequests.length; i++) {
        if (this.filterStatus == this.service.allWithdrawRequests[i].status || (this.filterStatus == 'Pending' && !this.service.allWithdrawRequests[i].status)) {
          this.service.filteredWithdrawRequests.push(this.service.allWithdrawRequests[i]);
        }
      }
    }
  }

  onChangeFile(event: EventTarget) {
    let eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    let target: HTMLInputElement = <HTMLInputElement>eventObj.target;

    this.selectedFile = target.files[0];

    const file = target.files[0];
    const reader = new FileReader();
    reader.onload = e => this.imgURL = reader.result;

    reader.readAsDataURL(file);

  }

  changePaymentStatus(user) {

    var self = this;
    self.loading = true;
    var index = self.service.allWithdrawRequests.findIndex(x => x.uid === user.uid);

    var formImageData: FormData = new FormData();
    formImageData.append('file', this.selectedFile);
    this.http.uploadImageFile(formImageData).then((res: any) => {
      var newData = {
        uid: user.uid,
        amount: user.earnings,
        status: "Completed",
        trips: user.trips,
        timeStamp: Number(new Date()),
        referenceImage: res.fileUrl,
      };
      firebase.database().ref('Payouts/').push(newData).then((result) => {
        self.imgURL = '';
        self.selectedFile = '';
        document.getElementById('paymentUpdateMd').click();
        self.service.allWithdrawRequests[index].status = 'Completed';
        self.service.pendigPayoutsCount--;
        self.service.filteredWithdrawRequests = self.service.allWithdrawRequests;
        self.filterStatus = 'All';
        self.searchQuery = '';
        self.loading = false;
        self.sendPayoutNotification(user, newData.amount)
      }).catch((err) => {
        self.loading = false;
        console.log(err.message);
        alert(err.message);
      });
    }).catch(err => {
      self.loading = false;
      console.log(err);
    });
  }

  sendPayoutNotification(user, amount: any) {
    var userData = this.service.allUsersList.find(ob => ob['uid'] === user.uid);
    if (userData) {
      var notifyData: any = { title: 'Orbit Withdraw Request Is Completed', message: 'Your Orbit Withdraw request of $' + amount + ' is completed by Admin.' }
      this.http.sendEmailNotifications([userData.email], notifyData)
      this.service.sendUserNotification(userData, notifyData)
    }
  }

}
